import { render, staticRenderFns } from "./ArticleList.vue?vue&type=template&id=2b1fec05&scoped=true"
import script from "./ArticleList.vue?vue&type=script&lang=js"
export * from "./ArticleList.vue?vue&type=script&lang=js"
import style0 from "./ArticleList.vue?vue&type=style&index=0&id=2b1fec05&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b1fec05",
  null
  
)

export default component.exports